module.exports = __webpack_public_path__ + "static/img/D.d3e5459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/D.png
// module id = JJFs
// module chunks = 0